export type NotifyType = 'error' | 'success' | 'info';

export interface Notification {
  id: number;
  type: NotifyType;
  message: string;
}

type Listener = (items: Notification[]) => void;

let items: Notification[] = [];
let nextId = 1;
const listeners = new Set<Listener>();

const emit = () => listeners.forEach((l) => l(items));

export function subscribeNotifications(listener: Listener): () => void {
  listeners.add(listener);
  listener(items);
  return () => {
    listeners.delete(listener);
  };
}

export function dismissNotification(id: number) {
  items = items.filter((n) => n.id !== id);
  emit();
}

function push(type: NotifyType, message: string) {
  if (!message) return;
  // Mesma mensagem repetida não empilha: substitui a anterior.
  items = items.filter((n) => !(n.type === type && n.message === message));
  const id = nextId++;
  items = [...items, { id, type, message }];
  emit();
  if (type !== 'error') {
    setTimeout(() => dismissNotification(id), 6000);
  }
}

/** Aviso inline (sem exigir clique em OK). Erros ficam até serem fechados. */
export const notifyError = (message: string) => push('error', message);
export const notifySuccess = (message: string) => push('success', message);
export const notifyInfo = (message: string) => push('info', message);
